import * as React from 'react';

import {useQuery, useMutation} from '@apollo/react-hooks';

import {EmailSequenceProgression} from 'shells/sequence-progression/email-sequence-progression';

import type {
    GetQueuedEmailsForEntity as GetQueuedEmailsForEntityQuery,
    GetQueuedEmailsForEntityVariables as GetQueuedEmailsForEntityQueryVariables,
    DeleteEmailSequence as DeleteEmailSequenceMutation,
    DeleteEmailSequenceVariables as DeleteEmailSequenceMutationVariables,
} from 'nutshell-graphql-types';

import DELETE_EMAIL_SEQUENCE from '../../../email/mailbox/graphql/mutations/delete-email-sequence.graphql';

import GET_QUEUED_EMAILS_FOR_ENTITY from './graphql/queries/get-queued-emails-for-entity.graphql';
import {QueuedEmailPreviewModal} from './queued-email-preview-modal';

import styles from './entity-page-email-sequences-section.module.css';

type Props = {
    entityId: string;
    entityType: 'company' | 'lead' | 'person';
};

export function EntityPageEmailSequencesSection(props: Props) {
    const [editionToShow, setEditionToShow] = React.useState<string | null | undefined>(undefined);

    const [cancelEmailProgression] = useMutation<
        DeleteEmailSequenceMutation,
        DeleteEmailSequenceMutationVariables
    >(DELETE_EMAIL_SEQUENCE);

    const {data, refetch} = useQuery<
        GetQueuedEmailsForEntityQuery,
        GetQueuedEmailsForEntityQueryVariables
    >(GET_QUEUED_EMAILS_FOR_ENTITY, {
        variables: {entityId: props.entityId},
        notifyOnNetworkStatusChange: true,
    });

    // @ts-expect-error
    const emailSequences = [];
    if (data && data.coreEntity) {
        data.coreEntity.queuedEmails
            .filter((email) => email.isNextScheduledEmail === true)
            .filter((email) => email.to && email.to.length)
            .forEach((email) => {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                email.emailSequence &&
                email.emailSequence.emailSequenceTemplate &&
                email.messageNumber &&
                email.to &&
                email.to.length &&
                // @ts-expect-error
                email.to[0].avatarEntity &&
                // @ts-expect-error
                (email.to[0].avatarEntity.__typename === 'Contact' ||
                    // @ts-expect-error
                    email.to[0].avatarEntity.__typename === 'Account')
                    ? emailSequences.push({
                          id: email.emailSequence.id,
                          name: email.emailSequence.emailSequenceTemplate.name,
                          htmlUrlPath: `/email/scheduled?filter[messageId]=${email.id}`,
                          length: email.emailSequence.messageCount,
                          totalSent: email.messageNumber - 1,
                          sendTime: email.deliveryTime,
                          nextEdition: {
                              name: email.subject,
                              emailTemplate: {id: email.id},
                          },
                          // @ts-expect-error
                          entity: email.to[0].avatarEntity,
                      })
                    : undefined;
            });
    }

    return (
        <>
            {emailSequences.length ? (
                <div className={styles.section}>
                    <EmailSequenceProgression
                        label='Personal email sequences'
                        // @ts-expect-error
                        emailSequences={emailSequences}
                        entityType={props.entityType}
                        showPreviewModal={(emailTemplateId) => {
                            setEditionToShow(emailTemplateId);
                        }}
                        onCancelSequenceProgression={(emailSequenceId: string) => {
                            return cancelEmailProgression({
                                variables: {
                                    payload: {
                                        emailSequence: {
                                            id: emailSequenceId,
                                        },
                                    },
                                },
                            }).then(() => refetch());
                        }}
                    />
                </div>
            ) : undefined}
            {editionToShow ? (
                <QueuedEmailPreviewModal
                    onClose={() => {
                        setEditionToShow(undefined);
                    }}
                    emailId={editionToShow}
                />
            ) : undefined}
        </>
    );
}
